import { render, staticRenderFns } from "./InvoiceModal.vue?vue&type=template&id=38c640b6&scoped=true"
import script from "./InvoiceModal.vue?vue&type=script&lang=js"
export * from "./InvoiceModal.vue?vue&type=script&lang=js"
import style0 from "./InvoiceModal.vue?vue&type=style&index=0&id=38c640b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c640b6",
  null
  
)

export default component.exports